import React from 'react';

// Single strip component
function SingleStrip({ photos, tilt }) {
  return (
    <div className="photostrip-single" style={{ transform: `rotate(${tilt}deg)` }}>
      <div className="photostrip-frame">
        <div className="photostrip-photos">
          {photos.map((photo, index) => (
            <div key={index} className="photostrip-photo-wrapper">
              <img
                src={photo}
                alt={`memory ${index + 1}`}
                className="photostrip-photo"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function PhotoStrip({ photos, locationName, side }) {
  if (!photos || photos.length === 0) return null;

  // Split photos into two strips
  const midpoint = Math.ceil(photos.length / 2);
  const strip1 = photos.slice(0, midpoint);
  const strip2 = photos.slice(midpoint);

  // If side is specified, render only that strip
  if (side === 'left') {
    return <SingleStrip photos={strip1} tilt={-3} />;
  }
  if (side === 'right') {
    return <SingleStrip photos={strip2} tilt={3} />;
  }

  // Default: render both side by side (fallback)
  return (
    <div className="photostrip-container">
      <SingleStrip photos={strip1} tilt={-3} />
      {strip2.length > 0 && <SingleStrip photos={strip2} tilt={3} />}
    </div>
  );
}
